import { Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type Asset from 'stores/Asset';

import DrawerButton from '../DrawerButton';

export interface RemoveFileButtonProps {
  asset: Asset;
}

function RemoveFileButton({ asset }: RemoveFileButtonProps) {
  const removeFile = () => {
    void asset.parent?.remove(asset.id);
  };

  return (
    <Popconfirm
      disabled={asset.loading}
      cancelText="No"
      okText="Yes"
      onConfirm={removeFile}
      placement="bottomRight"
      title="Are you sure you want to remove this file?"
    >
      <DrawerButton disabled={asset.loading}>Remove</DrawerButton>
    </Popconfirm>
  );
}

export default observer(RemoveFileButton);
